import { SxProps, Theme } from "@mui/material";

export const mainListItemButton = (isParentActive: boolean): SxProps<Theme> => ({
  borderRadius: 1,
  py: 0.5,
  px: 1.5,
  fontSize: 13,
  height: 36,
  minHeight: 36,
  mb: 0.5,
  color: isParentActive ? "primary.main" : "text.secondary",
  "& .MuiListItemIcon-root": {
    color: isParentActive ? "primary.main" : "text.secondary",
  },
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.04)",
  },
});

export const listItemButton = (isSelected: boolean): SxProps<Theme> => ({
  pl: 2,
  borderRadius: 1,
  bgcolor: isSelected ? "rgba(0, 0, 0, 0.06)" : "transparent",
  "&:hover": {
    bgcolor: "rgba(0, 0, 0, 0.08)",
  },
});

export const listItemText = (isSelected: boolean): SxProps<Theme> => ({
  fontSize: 13,
  fontWeight: isSelected ? "bold" : "normal",
});

export const SubMainBox: SxProps<Theme> = {
  mb: 1,
  borderTopRightRadius: 9999,
  borderBottomRightRadius: 9999,
};

export const subListItemButton = (isSelected: boolean): SxProps<Theme> => ({
  height: 36,
  minHeight: 36,
  py: 0.5,
  px: 1.5,
  mb: 1,
  borderRadius: 1,
  color: isSelected ? "primary.main" : "text.secondary",
  "& .MuiListItemIcon-root": {
    color: isSelected ? "primary.main" : "text.secondary",
  },
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.04)",
  },
});

export const subListItemText: SxProps<Theme> = {
  fontSize: 14,
  fontWeight: 400,
};
export const drawerBox = (drawerOpen: boolean, drawerWidth: number): SxProps<Theme> => ({
  width: { md: drawerOpen ? drawerWidth : 70 },
  flexShrink: { md: 0 },
  transition: "width 0.3s",
});

export const smallScreenDrawer = (drawerWidth: number): SxProps<Theme> => ({
  display: { xs: "block", md: "none" },
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    boxSizing: "border-box",
    backgroundColor: "white",
    position: "fixed",
  },
});

export const largeScreenDrawer = (drawerOpen: boolean, drawerWidth: number): SxProps<Theme> => ({
  display: { xs: "none", md: "block" },
  "& .MuiDrawer-paper": {
    width: drawerOpen ? drawerWidth : 70,
    transition: "width 0.3s",
    overflowX: "hidden",
    boxSizing: "border-box",
    backgroundColor: "white",
    position: "fixed",
    borderRight: "none",
  },
});

export const overflowSize = {
  scrollbarWidth: "thin",
  scrollbarColor: "#0A84FF transparent",

  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#0A84FF",
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#0060DF",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
};
